/* eslint-disable import/prefer-default-export */

export const setStickyFilter = (value) => ({
  type: 'SET_STICKY_FILTER',
  value,
});

export const setMarketViewPosition = (value) => ({
  type: 'SET_MARKET_VIEW_POSITION',
  value,
});

export const setFilterObject = (value) => ({
  type: 'SET_FILTER_OBJECT',
  value,
});

export const setAllPortfolioFilters = (value) => ({
  type: 'SET_PORTFOLIO_FILTERS',
  value,
});

export const setViewCheck = (value) => ({
  type: 'SET_VIEW_CHECK',
  value,
});

